import {
  GET_PROJECT_LOCATIONS_REQUEST,
  GET_PROJECT_LOCATIONS_SUCCESS,
  GET_PROJECT_LOCATIONS_FAILURE,
} from './actions'

const initialState = {
  isFetching: false,
  projectsLocation: {},
};

export default function projectsLocationReducer(state = initialState, { type, payload }) {
  switch(type) {
      case GET_PROJECT_LOCATIONS_REQUEST: {
          return {
              ...state,
              isFetching: true
          };
      }

      case GET_PROJECT_LOCATIONS_SUCCESS: {
          return {
              isFetching: false,
              projectsLocation: {
                  ...state.projectsLocation,
                  [payload.projectId]: payload.location
              }
          }
      }

      case GET_PROJECT_LOCATIONS_FAILURE: {
          return {
              ...state,
              isFetching: false
          }
      }
     
      default: {
          return { ...state };
      }
  }
}